export default function StatsGrid({ goals = 0, assists = 0, minutes = 0, opponent = "", result = "" }) {
  const cells = [
    { label: "Goals", value: goals, testid: "stat-goals" },
    { label: "Assists", value: assists, testid: "stat-assists" },
    { label: "Mins", value: minutes, testid: "stat-minutes" },
    { label: "Result", value: result || "—", testid: "stat-result" },
  ];
  return (
    <div className="mt-4">
      {opponent && (
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#737373] mb-2">
          vs <span className="text-white font-semibold">{opponent}</span>
        </div>
      )}
      <div className="grid grid-cols-4 gap-2">
        {cells.map((c) => (
          <div
            key={c.label}
            data-testid={c.testid}
            className="bg-[#0a0a0a] border border-[#262626] p-3 flex flex-col items-center rounded-sm"
          >
            <div className="font-display text-2xl md:text-3xl text-white leading-none">
              {c.value}
            </div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-[#737373] mt-1">
              {c.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
